import {
  AppBar,
  Box,
  IconButton,
  Toolbar,
  Typography,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Menu,
  MenuItem,
  Collapse,
} from "@mui/material";
import React, { useState, useEffect, useCallback } from "react";
import appLogo from "../../assets/images/header-footer/app-logo.png";
import MenuIcon from "@mui/icons-material/Menu";
import useWindowSize from "../../hooks/useWindowSize";
import { Link, useNavigate } from "react-router-dom";
import AccountCircle from "@mui/icons-material/AccountCircle";
import dashboard from "../../assets/images/dashboard/dashboard.png";
import customer from "../../assets/images/dashboard/customers.png";
import plans from "../../assets/images/dashboard/plans.png";
import themes from "../../assets/images/dashboard/themes.png";
// import content from "../../assets/images/dashboard/content.png";
import payment from "../../assets/images/dashboard/payment.png";
import dashboardActive from "../../assets/images/dashboard/dashboard-active.png";
import customersActive from "../../assets/images/dashboard/customers-active.png";
import plansActive from "../../assets/images/dashboard/plans-active.svg";
import themesActive from "../../assets/images/dashboard/themes-active.png";
import paymentActive from "../../assets/images/dashboard/payment-active.png";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { get } from "../../services/apiService";
import { useAuth } from "../../hooks/useAuth";
import i18n from "../../localization/LocalesConfig";
import langIcon  from '../../assets/images/header-footer/language.png';


const Header = ({ contentNavigation }) => {
  // const langLabel =
  // localStorage.getItem("preferredLanguage") === "ar" ? "Arabic" : "English";
// const userId = localStorage.getItem("userId");
// const [activeLanguage, setActiveLanguage] = useState(langLabel);
const [anchorEl, setAnchorEl] = useState(null);
const [langEl, setLangEl] = useState(null);
const { updateCurrentLang } = useAuth();

  const { width } = useWindowSize();
  const navigate = useNavigate();
  const [userInfo, setUserInfo] = useState({});
  const [activeItem, setActiveItem] = useState({
    parent: "Dashboard",
    child: null,
  });

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [expanded, setExpanded] = useState(null);

  const toggleExpand = (event, label) => {
    setExpanded((prev) => (prev === label ? null : label));
  };

  const navigationItems = [
    {
      label: "Dashboard",
      icon: dashboard,
      activeIcon: dashboardActive,
      link: "/dashboard",
    },
    {
      label: "Customers",
      icon: customer,
      activeIcon: customersActive,
      link: "/customers",
    },
    {
      label: "Hosting Plan",
      icon: plans,
      activeIcon: plansActive,
      link: "/plans",
    },
    {
      label: "Themes",
      icon: themes,
      activeIcon: themesActive,
      link: "/theme",
    },
    {
      label: "Payment",
      icon: payment,
      activeIcon: paymentActive,
      link: "/payment",
    },
  ];
  if (contentNavigation?.children?.length > 0) {
    navigationItems.push(contentNavigation);
  }

  // Function to handle closing the drawer
  const handleNavigationClick = (item) => {
    setActiveItem({ parent: item.label, child: null });
    // setDrawerOpen(false); // Close drawer on navigation item click
    if (item.link) navigate(item.link); // Navigate to the link
  };

  const handleLogout = () => {
    handleMenuClose();
    localStorage.removeItem("token");
    navigate("/signin");
  };
  const handleUpdatePassword = () => {
    handleMenuClose();
    navigate("/update-password");
  };


  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const fetchUserInformation = useCallback(async () => {
    const userId = localStorage.getItem("userId");
    const response = await get(`users/${userId}`, {}, onLoading);
    if (response?.status === 200 || response?.status === 201) {
      setUserInfo(response.data);
    }
  }, []);

  useEffect(() => {
    fetchUserInformation();
  }, [fetchUserInformation]);

  const onLoading = () => {
    console.log("do nothing");
  };

  const languages = [
    {
      label: "English",
      lang: "en",
    },
    {
      label: "Arabic",
      lang: "ar",
    },
  ];

  const handleLangMenuOpen = (event) => {
    if (event.currentTarget) {
      setLangEl(event.currentTarget); // Set anchor to the icon button
    }
  };

  const handleChangeLanguage = (lang) => {
    setLangEl(null); // Always close the menu
    // if (lang === "en" || lang === "ar") {
    localStorage.setItem("preferredLanguage", lang);
    localStorage.setItem("direction", lang === "en" ? "ltr" : "rtl");
    i18n?.changeLanguage(lang);
    // setActiveLanguage(lang === "en" ? "English" : "Arabic");
    updateCurrentLang(lang); // Always update context
    // }
  };


  return (
    <AppBar
      position="sticky"
      sx={{
        backgroundColor: "#F5F5F5",
        // background:"grey",
        boxShadow: 0,
        padding: "0.2%",
        width: "100%",
        overflowX: "hidden",
        overflowY: "hidden",
        height: "60px",
      }}
    >
      <Toolbar
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          overflowX: "hidden",
          overflowY: "hidden",
        }}
      >
        {/* Left: Logo */}
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Typography variant="h6" sx={{ fontWeight: "bold", color: "#000" }}>
            <Link to="/">
              <img
                src={appLogo}
                alt="logo"
                width={120}
                height={51.68}
                style={{ marginTop: "13%" }}
              />
            </Link>
          </Typography>
        </Box>

        {/* Right: Profile, Language, and Hamburger Icon */}

        <Box
          sx={{
            display: "flex",
            // textAlign: "end",
            flexDirection: "flex-end",
            // marginTop: "3%",
            // backgroundColor: "grey",
            alignItems: "center",
          }}
        >
          {width > 600 && (
            <><Box sx={{ flexDirection: "column" }}>
              <Box sx={{ flexDirection: "flex-start" }}>
                <Typography
                  sx={{
                    color: "#004D8A",
                    fontSize: width > 600 ? "16px" : "12px",
                    fontWeight: "700",
                    marginLeft: "30px",
                    fontFamily: "Tajawal-Regular",
                  }}
                >
                  {"Welcome"} {userInfo.fullName ? userInfo.fullName : "Guest"}
                </Typography>
                <Typography
                  sx={{
                    color: "#004D8A",
                    fontSize: width > 600 ? "16px" : "12px",
                    fontWeight: "700",
                    marginLeft: "30px",
                    fontFamily: "Tajawal-Regular",
                  }}
                >
                  {userInfo.email && userInfo.email}
                </Typography>
              </Box>
            </Box>
            
            <IconButton sx={{ color: "#000" }} onClick={handleLangMenuOpen}>
                <img
                  src={langIcon}
                  alt="language"
                  width={width > 600 ? 50 : 30}
                  height={width > 600 ? 50 : 30} />
              </IconButton><Menu
                anchorEl={langEl}
                open={Boolean(langEl)} // Open menu if anchorEl is set
                onClose={() => setLangEl(null)}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }} // Set dropdown position
                transformOrigin={{ vertical: "top", horizontal: "right" }}
                PaperProps={{
                  sx: {
                    width: "100px",
                    display: "flex",
                    justifyContent: "center",
                    textAlign: "center", // Set your desired width here
                  },
                }}
              >
                {languages && languages?.length > 0 ? (
                  languages?.map((item, index) => (
                    <MenuItem
                      key={index}
                      onClick={() => handleChangeLanguage(item.lang)}
                      style={{
                        color: "#004D8A",
                        fontFamily: "Tajawal-Bold",
                        cursor: "pointer",
                      }}
                    >
                      {item.label}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem style={{ textAlign: "center" }}>No Languages</MenuItem>
                )}
              </Menu></>
       
          )}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: width > 600 ? "15px" : "1px",
            }}
          >
            <IconButton onClick={handleMenuOpen}>
              <AccountCircle
                sx={{ fontSize: width > 600 ? 50 : 36, color: "#004D8A" }}
              />
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              transformOrigin={{ vertical: "top", horizontal: "right" }}
              PaperProps={{
                sx: {
                  width: "150px",
                  display: "flex",
                  justifyContent: "center",
                  textAlign: "center",
                  fontFamily: "Tajawal-Bold",
                },
              }}
            >
              <MenuItem
                onClick={handleUpdatePassword}
                style={{
                  color: "#004D8A",
                  fontFamily: "Tajawal-Bold",
                  cursor: "pointer",
                }}
              >
                Update Password
              </MenuItem>
              <MenuItem
                onClick={handleLogout}
                style={{
                  color: "#004D8A",
                  fontFamily: "Tajawal-Bold",
                  cursor: "pointer",
                }}
              >
                Sign Out
              </MenuItem>
            </Menu>

            {/* Hamburger Icon for Mobile */}
            {width <= 1032 && (
              <IconButton
                sx={{ color: "#000" }}
                onClick={() => setDrawerOpen(true)}
              >
                <MenuIcon />
              </IconButton>
            )}
          </Box>
        </Box>
      </Toolbar>

      {/* Sidebar for Mobile View */}
      <Drawer
        anchor="left"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)} // Close the drawer on outside click
      >
        <Box
          sx={{
            width: 250, // Adjust width to match design
            padding: "20px 15px",
          }}
          role="presentation"
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: 80, // Space for the logo
              marginBottom: "20px",
              marginLeft: "-35%",
            }}
          >
            <img
              src={appLogo}
              alt="App Logo"
              style={{ maxHeight: 50, objectFit: "contain" }}
            />
          </Box>

          <List>
            {navigationItems.map((item) => (
              <React.Fragment key={item.label}>
                <ListItem
                  button
                  component={Link}
                  to={item.link}
                  onClick={() => handleNavigationClick(item)} // Handle navigation click
                  sx={{
                    color:
                      activeItem.parent === item.label ? "#3173B1" : "#868686",
                    fontSize: "20px",
                    fontFamily:
                      activeItem.parent === item.label
                        ? "Tajawal-Bold"
                        : "Tajawal-Regular",
                  }}
                >
                  <img
                    src={
                      activeItem.parent === item.label
                        ? item.activeIcon
                        : item.icon
                    }
                    alt={item.label}
                    style={{
                      marginRight: "10px",
                      width: "20px",
                      height: "20px",
                    }}
                  />
                  <ListItemText
                    primary={item.label}
                    primaryTypographyProps={{
                      fontSize: "18px",
                      fontFamily: "Tajawal-Regular",
                    }}
                  />
                  {item.children &&
                    (expanded === item.label ? (
                      <ExpandLess
                        onClick={(event) => toggleExpand(event, item.label)}
                      />
                    ) : (
                      <ExpandMore
                        onClick={(event) => toggleExpand(event, item.label)}
                      />
                    ))}
                </ListItem>

                {item.children && (
                  <Collapse
                    in={expanded === item.label}
                    timeout="auto"
                    unmountOnExit
                  >
                    <List component="div" disablePadding>
                      {item.children.map((child) => (
                        <ListItem
                          button
                          component={Link}
                          to={child.link}
                          key={child.label}
                          onClick={() => {
                            setActiveItem({
                              parent: item.label,
                              child: child.label,
                            });
                          }}
                          sx={{
                            color:
                              activeItem.child === child.label
                                ? "#3173B1"
                                : "#868686",
                            fontSize: "16px",
                            fontFamily:
                              activeItem.child === child.label
                                ? "Tajawal-Bold"
                                : "Tajawal-Regular",
                            pl: 4,
                          }}
                        >
                          <ListItemText
                            primary={child.label}
                            primaryTypographyProps={{
                              fontSize: "16px",
                              fontFamily: "Tajawal-Regular",
                            }}
                          />
                        </ListItem>
                      ))}
                    </List>
                  </Collapse>
                )}
              </React.Fragment>
            ))}
            <ListItem>
              <ListItemText
                primary={"Logout"}
                primaryTypographyProps={{
                  fontSize: "16px",
                  fontFamily: "Tajawal-Regular",
                  color:"#3173B1"
                }}
                onClick={handleLogout}
              ></ListItemText>
            </ListItem>
          </List>
        </Box>
      </Drawer>
    </AppBar>
  );
};

export default Header;
